import { ToolBarContainer, } from "./styled";
import React from "react";
import { CustomerFilter, CustomerFilterModel } from "./filter/customer-filter";
import { ManagementPageType } from "../../../../management-pages/user-order-management/management-data-container";
import { OrderFilter } from "./filter/order-filter";
import { HistoryFilter } from "./filter/history-filter";
import { HistoryFilterModel } from "../../../shared/models/order/history-filter.model";
import { SearchInput } from "./filter/search-input";
import { HistorySearchInput } from "./filter/history-search-inputs";

export const AdminToolPanel = ({ filter, setFilter, type, exportFunction }: AdminToolPanelProps) => {
    return (
        <>
            <ToolBarContainer style={{ paddingTop: '1rem' }}>
                <AdminFilter filter={filter} exportFunction={exportFunction} setFilter={setFilter} type={type} />

                {type === ManagementPageType.HISTORY
                    ? <HistorySearchInput filter={filter} filterChanged={setFilter} />
                    : <SearchInput filter={filter} filterChanged={setFilter} />
                }
            </ToolBarContainer>
        </>
    )
}

const AdminFilter = ({ filter, setFilter, type, exportFunction }: AdminToolPanelProps) => {
    switch (type) {
        case ManagementPageType.WAREHOUSE_WORKERS:
        case ManagementPageType.CUSTOMERS:
            return <CustomerFilter filter={filter} exportFunction={exportFunction} setFilter={setFilter} />
        case ManagementPageType.ALL_ORDERS:
            return <OrderFilter onFilterChange={setFilter}
                preLoadedFilter={filter}
                mobileFilterOpened={false}
                setMobileFilterOpened={() => void (0)} />
        case ManagementPageType.HISTORY:
            return <HistoryFilter onFilterChange={setFilter}
                mobileFilterOpened={false}
                setMobileFilterOpened={() => void (0)} />
        case ManagementPageType.MOBILE_ORDERS:
            return <CustomerFilter filter={filter} exportFunction={exportFunction} setFilter={setFilter} filterType={ManagementPageType.MOBILE_ORDERS} />
        default:
            return <></>
    }
}

interface AdminToolPanelProps {
    filter: CustomerFilterModel | HistoryFilterModel,
    setFilter: (filter: CustomerFilterModel | HistoryFilterModel) => void;
    type: ManagementPageType;
    exportFunction?: () => Promise<void>
}